import { GreyFlexBoxHover } from 'components/common/StyledBoxes'
import EngagementListItem from 'components/EngagementListItem'
import InfiniteList from 'components/InfiniteList'
import {
  FilterableEngagementField,
  SortableEngagementField,
  SortDirection,
  useUserEngagementsQuery
} from 'graphql/generated'
import { useQueryErrorHandler } from 'hooks'
import { itemsPerPage } from 'lib/config'
import React from 'react'
import language from 'services/Language'

export type FeedTypes = Array<
  FilterableEngagementField.HOSTED | FilterableEngagementField.SPOKE_AT
>

interface IProps {
  profileId: string
  type?: FeedTypes
}

export const EventsFeed: React.FC<IProps> = ({ type, profileId }) => {
  const onError = useQueryErrorHandler(
    'Failed to load events. Please try again later.'
  )

  let filters = [FilterableEngagementField.TYPE_SOCIAL]

  if (type) {
    filters = [FilterableEngagementField.TYPE_SOCIAL, ...type]
  }

  const { loading, data, networkStatus, fetchMore } = useUserEngagementsQuery({
    notifyOnNetworkStatusChange: true,
    variables: {
      id: profileId,
      filters: filters,
      sort: {
        direction: SortDirection.DESCENDING,
        field: SortableEngagementField.START_TIME
      },
      engagementConnection: {
        first: itemsPerPage
      }
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    onError
  })

  const edges = data?.user?.engagements?.edges
  const pageInfo = data?.user?.engagements?.pageInfo
  const loadingMore = networkStatus === 3

  const loadMore = () => {
    if (!pageInfo || !pageInfo.hasNextPage) {
      return
    } else if (loading || loadingMore) {
      return
    }

    fetchMore({
      variables: {
        engagementConnection: {
          first: itemsPerPage,
          after: pageInfo.endCursor
        }
      }
    })
  }

  return (
    <InfiniteList
      items={edges}
      loadMore={loadMore}
      loading={loading}
      loadingMore={loadingMore}
      emptyText={language.common.noItemsFound}
      renderItem={edge => (
        <div className="my-2" key={edge.node.id}>
          <GreyFlexBoxHover className="p-2 rounded-lg">
            <EngagementListItem
              engagement={edge.node}
              showUserRoleBadge={true}
              userId={profileId}
            />
          </GreyFlexBoxHover>
        </div>
      )}
    />
  )
}
